module.exports = __webpack_public_path__ + "img/bl2fl01_center_002.b684796b.png";